// a notification details component

import { init, classModule,toVNode, propsModule, styleModule, datasetModule, eventListenersModule, h } from 'snabbdom';
import Core from 'hvx/modules/CoreModule';
import { delegate } from './helpers';
import { itemDetailView } from './components';
const patch = init([
  classModule,
  propsModule,
  styleModule,
  datasetModule,
  eventListenersModule,
]);

export default class details {
  /**
       * 
       * @param {NotificationStore} store 
       * @returns 
       */
  constructor(store, options) {
    const option = options || {};
    if (details._instance) {
      return details._instance;
    }
    details._instance = this;
    
    
    this._isWindowOpen = false;
    this._window = null;
    this.notificationStore = store;
    this.el = document.createElement('div');
    this.el.innerHTML = 'Select A Notification to View Details';
    // this.el.innerHTML = 'test';
    this.el.classList.add('notify-inbox-container');
    // document.body.appendChild(this.el);
    this.vnode = toVNode(this.el);
    this.useLocalTime = option.useLocalTime || true;
    // document.body.appendChild(elem);
    // Core.EventManager.addListener('hvx.notification.toggle', this._onWindowToggle.bind(this));
    Core.EventManager.addListener('hvx.notification.detials', this._onWindowToggle.bind(this));
    
    store.addEventListener('save', () => {
      if (this._isWindowOpen) {
        this.render();
      }
    });
    this._bindEvents();
  }
  _bindEvents() {
    delegate(document, '.inbox-toggle', 'click', this._toggledetails.bind(this));
  }
  _toggledetails(e) {
    e.preventDefault();
    e.stopPropagation();
    this.el.classList.toggle('open');
  }
  _openWindow() {
    if (!this._window) {
      this._window = this._createWindow();
    }
    this._window.show();
    this._isWindowOpen = true;
  }
  _createWindow() {
   
    const element = document.getElementById('cMainComponent-body');
    
    // get the bounding rectangle of the element
    const rect = element.getBoundingClientRect();
    
    // log the width and height of the element
    console.log(`Width: ${rect.width}, Height: ${rect.height}`);
    // eslint-disable-next-line no-undef
    return Ext.create('Ext.window.Window', {
      title: 'Notification Details',
      cls: 'notify-details-window',
      renderTo: 'cMainComponent-body',
      // tools:[{
      //   type:'refresh',
      //   tooltip: 'Refresh form Data',
      //   // hidden:true,
      //   handler: function(event, toolEl, panelHeader) {
      //     // refresh logic
      //   }
      // },
      // {
      //   type:'help',
      //   tooltip: 'Get Help',
      //   callback: function(panel, tool, event) {
      //     // show help here
      //   }
      // }],
      constrain: true,
      constrainTo: element,
      width: 500,
      height: 500,
      y: 10,
      x: rect.width - 510,
      closeAction: 'hide',
      maximizable: true,
      layout: 'fit',
      listeners: {
        afterrender: (win) =>{
          
          win.body.appendChild(this.el);
          this.render();
        },
        close: () => {
          Core.EventManager.fireEvent('hvx.notification.toggle', true);
          Core.EventManager.fireEvent('hvx.notification-detail.toggle', false);
          this._isWindowOpen = false;
        },
      }
    });
  }
  /**
   *  toggle the active state of a notification
  * @param {import('./store').NotificationStoreItem} notification
   * 
   */
  _ToggleActive(notification){
    this.notificationStore.toggleActive(notification);

  } 


  _onWindowToggle() {
    if (!this._window) {
      this._window = this._createWindow();
    }
    if (!this._isWindowOpen) {
      Core.EventManager.fireEvent('hvx.notification.toggle', false);

      this._window.show();
      this.render();
      this._isWindowOpen = true;
    } else {
      this._window.hide();
      this._isWindowOpen = false;
    }
  }
  toolbar() {
    return h('div', { class: { 'details-toolbar': true } },  [
      h('button.bi bi-caret-left-fill', {
        on: {
          click: () => {
            this.notificationStore.detachPrev();
          }
        }
      }),
      h('button.bi bi-caret-right-fill', {
        on: {
          click: () => {
            this.notificationStore.detacheNext();
  
          }
        }
      }),
    ]);


  }

  /**
   * 
   * @param {import("./notification-item").NotificationStoreItem} notification 
   * @returns 
   */ 
  renderdetailsItem(notification) {

    return h('div.notify-item', {
      dataset: {
        id: notification.id
      },
      class: {
        'unread': !notification.read,
      },
      style: {

        // TODO: add animation
        // remove: {
        //   transition: 'opacity 1s',
        //   opacity: '0' ,
        // }
      },
    }, [
      itemDetailView(notification, {
        useLocalTime: this.useLocalTime,
        toggleActive: this._ToggleActive.bind(this)
      })
      ,
    ]);  }

  render() {
    const notifications = this.notificationStore.all();
    if (notifications.length === 0) {
      this.el.innerHTML = '<h3 class="empty-placeholder">Your details is Empty</h3>';
      return;
    }
    const vnode = h('div.notify-detials-container ', [
      this.toolbar(),
      // h('div', { class: { 'inbox-toggle': true } }, 'details'),
      h('div.notify-list',  
        this.notificationStore.all('detail').map((item) => this.renderdetailsItem(item))
      ),
    ]);
    this.vnode = patch(this.vnode, vnode);
  }


}